export const PROJECTS_COMPONENTS_QUERY_PARAMS = [
	'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page',
];
